var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowRewardsWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.0002C7.1 19.4002 5.33333 22.8336 5 24.5002H18C17.6667 22.5002 15.9 18.6002 11.5 19.0002Z",
    fill: "#F7ED90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1H4.5C4.5 4.16667 5.5 13.5 11.5 13.5C17.5926 13.5 18.5 6.16667 18.5 1Z",
    fill: "#F7ED90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5893 13.2612C13.8227 13.2612 15.3482 12.406 16.384 11.1472M11.5893 13.2612C3.13392 13.2607 4.82452 1 4.82452 1H11.5893H18.3542C18.3542 1 18.5563 2.4651 18.4714 4.38241M11.5893 13.2612C11.5893 13.2612 11.5896 16.0433 11.5893 19.1805M18.4714 4.38241C18.4714 4.38241 19.1059 3.0827 20.4682 3.53681C23.616 4.58605 21.8696 8.77213 19.6226 10.7244C18.3619 11.8198 16.384 11.1472 16.384 11.1472M18.4714 4.38241C18.3757 6.54679 17.9144 9.28743 16.384 11.1472M11.5893 19.1805C17.5086 19.1805 17.9307 24.2541 17.9307 24.2541H5.2467C5.2467 24.2541 5.67012 19.1805 11.5893 19.1805ZM4.70707 4.38241C4.70707 4.38241 4.07262 3.0827 2.71029 3.53681C-0.437443 4.58605 1.30892 8.77213 3.55589 10.7244C4.81664 11.8198 6.79455 11.1472 6.79455 11.1472C5.26416 9.28743 4.80281 6.54679 4.70707 4.38241Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4341 10.7245C13.7025 10.3017 14.9709 9.0333 15.3937 7.76489",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowRewardsWork);
export default __webpack_public_path__ + "static/media/how-rewards-work.1bc26d7c94fac31e83151392c87a7d91.svg";
export { ForwardRef as ReactComponent };